var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "oldPassword" } },
            [
              _c("el-input", {
                attrs: {
                  id: "old-password",
                  type: "password",
                  "show-password": "",
                  placeholder: _vm.$t("auth changePassword.yourPassword"),
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.form.oldPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "oldPassword", $$v)
                  },
                  expression: "form.oldPassword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "newPassword" } },
            [
              _c("el-input", {
                attrs: {
                  id: "new-password1",
                  type: "password",
                  "show-password": "",
                  placeholder: _vm.$t("auth changePassword.newPassword"),
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.form.newPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "newPassword", $$v)
                  },
                  expression: "form.newPassword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "repeatNewPassword" } },
            [
              _c("el-input", {
                attrs: {
                  id: "new-password2",
                  type: "password",
                  "show-password": "",
                  placeholder: _vm.$t("auth changePassword.repeatPassword"),
                  disabled: _vm.loading,
                },
                model: {
                  value: _vm.form.repeatNewPassword,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "repeatNewPassword", $$v)
                  },
                  expression: "form.repeatNewPassword",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c("Auth-PasswordChecker", {
                ref: "passwordChecker",
                attrs: { password: _vm.form.newPassword },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticClass: "signinBtn",
                  attrs: {
                    id: "change-password-button",
                    loading: _vm.loading,
                    size: "medium",
                    type: "primary",
                  },
                  on: { click: _vm.onClickButton },
                },
                [_vm._v(_vm._s(_vm.$t("auth changePassword.submitButton")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }